import Utils from 'src/utils';

import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_PLANNER_REQUESTS_REQUEST = 'LOAD_PLANNER_REQUESTS_REQUEST';
export const LOAD_PLANNER_REQUESTS_SUCCESS = 'LOAD_PLANNER_REQUESTS_SUCCESS';
export const LOAD_PLANNER_REQUESTS_FAIL = 'LOAD_PLANNER_REQUESTS_FAIL';

export const POST_PLANNER_REQUEST_REQUEST = 'POST_PLANNER_REQUEST_REQUEST';
export const POST_PLANNER_REQUEST_SUCCESS = 'POST_PLANNER_REQUEST_SUCCESS';
export const POST_PLANNER_REQUEST_FAIL = 'POST_PLANNER_REQUEST_FAIL';

export const POST_PLANNER_REQUEST_CONFIRMATION_REQUEST = 'POST_PLANNER_REQUEST_CONFIRMATION_REQUEST';
export const POST_PLANNER_REQUEST_CONFIRMATION_SUCCESS = 'POST_PLANNER_REQUEST_CONFIRMATION_SUCCESS';
export const POST_PLANNER_REQUEST_CONFIRMATION_FAIL = 'POST_PLANNER_REQUEST_CONFIRMATION_FAIL';

export const PUT_MULTIPLE_PLANNER_REQUESTS_REQUEST = 'PUT_MULTIPLE_PLANNER_REQUESTS_REQUEST';
export const PUT_MULTIPLE_PLANNER_REQUESTS_SUCCESS = 'PUT_MULTIPLE_PLANNER_REQUESTS_SUCCESS';
export const PUT_MULTIPLE_PLANNER_REQUESTS_FAIL = 'PUT_MULTIPLE_PLANNER_REQUESTS_FAIL';

export const PUT_PLANNER_REQUEST_REQUEST = 'PUT_PLANNER_REQUEST_REQUEST';
export const PUT_PLANNER_REQUEST_SUCCESS = 'PUT_PLANNER_REQUEST_SUCCESS';
export const PUT_PLANNER_REQUEST_FAIL = 'PUT_PLANNER_REQUEST_FAIL';

export const DELETE_PLANNER_REQUESTS_REQUEST = 'DELETE_PLANNER_REQUESTS_REQUEST';
export const DELETE_PLANNER_REQUESTS_SUCCESS = 'DELETE_PLANNER_REQUESTS_SUCCESS';
export const DELETE_PLANNER_REQUESTS_FAIL = 'DELETE_PLANNER_REQUESTS_FAIL';

export const LOAD_PLANNER_REQUESTS_TYPES_REQUEST = 'LOAD_PLANNER_REQUESTS_TYPES_REQUEST';
export const LOAD_PLANNER_REQUESTS_TYPES_SUCCESS = 'LOAD_PLANNER_REQUESTS_TYPES_SUCCESS';
export const LOAD_PLANNER_REQUESTS_TYPES_FAIL = 'LOAD_PLANNER_REQUESTS_TYPES_FAIL';

export const POST_PLANNER_REQUESTS_TYPES_REQUEST = 'POST_PLANNER_REQUESTS_TYPES_REQUEST';
export const POST_PLANNER_REQUESTS_TYPES_SUCCESS = 'POST_PLANNER_REQUESTS_TYPES_SUCCESS';
export const POST_PLANNER_REQUESTS_TYPES_FAIL = 'POST_PLANNER_REQUESTS_TYPES_FAIL';

export const PUT_PLANNER_REQUESTS_TYPES_REQUEST = 'PUT_PLANNER_REQUESTS_TYPES_REQUEST';
export const PUT_PLANNER_REQUESTS_TYPES_SUCCESS = 'PUT_PLANNER_REQUESTS_TYPES_SUCCESS';
export const PUT_PLANNER_REQUESTS_TYPES_FAIL = 'PUT_PLANNER_REQUESTS_TYPES_FAIL';

export const DELETE_PLANNER_REQUESTS_TYPES_REQUEST = 'DELETE_PLANNER_REQUESTS_TYPES_REQUEST';
export const DELETE_PLANNER_REQUESTS_TYPES_SUCCESS = 'DELETE_PLANNER_REQUESTS_TYPES_SUCCESS';
export const DELETE_PLANNER_REQUESTS_TYPES_FAIL = 'DELETE_PLANNER_REQUESTS_TYPES_FAIL';

const loadPlannerRequestsRequest = () => ({ type: LOAD_PLANNER_REQUESTS_REQUEST });
const loadPlannerRequestsSuccess = (payload) => ({ type: LOAD_PLANNER_REQUESTS_SUCCESS, payload });
const loadPlannerRequestsFail = (err) => ({ type: LOAD_PLANNER_REQUESTS_FAIL, err });

const postPlannerRequestRequest = () => ({ type: POST_PLANNER_REQUEST_REQUEST });
const postPlannerRequestSuccess = (payload) => ({ type: POST_PLANNER_REQUEST_SUCCESS, payload });
const postPlannerRequestFail = (err) => ({ type: POST_PLANNER_REQUEST_FAIL, err });

const postPlannerRequestConfirmationRequest = () => ({ type: POST_PLANNER_REQUEST_CONFIRMATION_REQUEST });
const postPlannerRequestConfirmationSuccess = (payload) => ({ type: POST_PLANNER_REQUEST_CONFIRMATION_SUCCESS, payload });
const postPlannerRequestConfirmationFail = (err) => ({ type: POST_PLANNER_REQUEST_CONFIRMATION_FAIL, err });

const putMultiplePlannerRequestsRequest = () => ({ type: PUT_MULTIPLE_PLANNER_REQUESTS_REQUEST });
const putMultiplePlannerRequestsSuccess = (payload) => ({ type: PUT_MULTIPLE_PLANNER_REQUESTS_SUCCESS, payload });
const putMultiplePlannerRequestsFail = (err) => ({ type: PUT_MULTIPLE_PLANNER_REQUESTS_FAIL, err });

const putPlannerRequestRequest = () => ({ type: PUT_PLANNER_REQUEST_REQUEST });
const putPlannerRequestSuccess = (payload) => ({ type: PUT_PLANNER_REQUEST_SUCCESS, payload });
const putPlannerRequestFail = (err) => ({ type: PUT_PLANNER_REQUEST_FAIL, err });

const deletePlannerRequestsRequest = () => ({ type: DELETE_PLANNER_REQUESTS_REQUEST });
const deletePlannerRequestsSuccess = (payload) => ({ type: DELETE_PLANNER_REQUESTS_SUCCESS, payload });
const deletePlannerRequestsFail = (err) => ({ type: DELETE_PLANNER_REQUESTS_FAIL, err });

const loadPlannerRequestsTypesRequest = () => ({ type: LOAD_PLANNER_REQUESTS_TYPES_REQUEST });
const loadPlannerRequestsTypesSuccess = (payload) => ({ type: LOAD_PLANNER_REQUESTS_TYPES_SUCCESS, payload });
const loadPlannerRequestsTypesFail = (err) => ({ type: LOAD_PLANNER_REQUESTS_TYPES_FAIL, err });

const postPlannerRequestsTypesRequest = () => ({ type: POST_PLANNER_REQUESTS_TYPES_REQUEST });
const postPlannerRequestsTypesSuccess = (payload) => ({ type: POST_PLANNER_REQUESTS_TYPES_SUCCESS, payload });
const postPlannerRequestsTypesFail = (err) => ({ type: POST_PLANNER_REQUESTS_TYPES_FAIL, err });

const putPlannerRequestsTypesRequest = () => ({ type: PUT_PLANNER_REQUESTS_TYPES_REQUEST });
const putPlannerRequestsTypesSuccess = (payload) => ({ type: PUT_PLANNER_REQUESTS_TYPES_SUCCESS, payload });
const putPlannerRequestsTypesFail = (err) => ({ type: PUT_PLANNER_REQUESTS_TYPES_FAIL, err });

const deletePlannerRequestsTypesRequest = () => ({ type: DELETE_PLANNER_REQUESTS_TYPES_REQUEST });
const deletePlannerRequestsTypesSuccess = (payload) => ({ type: DELETE_PLANNER_REQUESTS_TYPES_SUCCESS, payload });
const deletePlannerRequestsTypesFail = (err) => ({ type: DELETE_PLANNER_REQUESTS_TYPES_FAIL, err });

export const loadPlannerRequests = (params) => (dispatch) => {
  dispatch(loadPlannerRequestsRequest());
  return communicate({ url: 'PlannerRequests', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      dispatch(loadPlannerRequestsSuccess(data.Data));
    }).catch((err) => {
      dispatch(loadPlannerRequestsFail(err));
      toastrError(err);
    });
};

export const postPlannerRequest = (params) => (dispatch) => {
  dispatch(postPlannerRequestRequest());
  return communicate({ url: 'PlannerRequests', data: params, method: 'post' })
    .then(({ data }) => {
      dispatch(postPlannerRequestSuccess(data.Data));
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(postPlannerRequestFail(err));
      toastrError(err);
    });
};

export const postPlannerRequestConfirmation = (params) => (dispatch) => {
  dispatch(postPlannerRequestConfirmationRequest());
  return communicate({ url: 'PlannerRequests/SetConfirmation', data: params, method: 'post' })
    .then(({ data }) => {
      dispatch(postPlannerRequestConfirmationSuccess(data.Data));
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(postPlannerRequestConfirmationFail(err));
      toastrError(err);
    });
};

export const putMultiplePlannerRequests = (params) => (dispatch) => {
  dispatch(putMultiplePlannerRequestsRequest());
  return communicate({ url: 'PlannerRequests/MultiUpdate', data: params, method: 'put' })
    .then(({ data }) => {
      dispatch(putMultiplePlannerRequestsSuccess(data.Data));
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(putMultiplePlannerRequestsFail(err));
      toastrError(err);
    });
};

export const putPlannerRequest = (params) => (dispatch) => {
  dispatch(putPlannerRequestRequest());
  return communicate({ url: 'PlannerRequests', data: params, method: 'put' })
    .then(({ data }) => {
      dispatch(putPlannerRequestSuccess(data.Data));
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(putPlannerRequestFail(err));
      toastrError(err);
    });
};

export const deletePlannerRequests = ({ ids }) => (dispatch) => {
  dispatch(deletePlannerRequestsRequest());
  return communicate({ url: 'PlannerRequests', getParams: Utils.objects.getQueryStringFromObject({ ids }), method: 'delete' })
    .then(({ data }) => {
      dispatch(deletePlannerRequestsSuccess(ids));
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(deletePlannerRequestsFail(err));
      toastrError(err);
    });
};

export const loadPlannerRequestsTypes = () => (dispatch) => {
  dispatch(loadPlannerRequestsTypesRequest());
  return communicate({ url: 'PlannerRequestTypes' })
    .then(({ data }) => {
      dispatch(loadPlannerRequestsTypesSuccess(data.Data));
    }).catch((err) => {
      dispatch(loadPlannerRequestsTypesFail(err));
      toastrError(err);
    });
};

export const postPlannerRequestsTypes = (params) => (dispatch) => {
  dispatch(postPlannerRequestsTypesRequest());
  return communicate({ url: 'PlannerRequestTypes', method: 'post', data: params })
    .then(({ data }) => {
      dispatch(postPlannerRequestsTypesSuccess(data.Data));
      toastrSuccess(data);
      return ({ res: data.Data });
    }).catch((err) => {
      dispatch(postPlannerRequestsTypesFail(err));
      toastrError(err);
      return ({ err });
    });
};

export const putPlannerRequestsTypes = (params) => (dispatch) => {
  dispatch(putPlannerRequestsTypesRequest());
  return communicate({ url: 'PlannerRequestTypes', data: params, method: 'put' })
    .then(({ data }) => {
      dispatch(putPlannerRequestsTypesSuccess(data.Data));
      toastrSuccess(data);
      return ({ res: data.Data });
    }).catch((err) => {
      dispatch(putPlannerRequestsTypesFail(err));
      toastrError(err);
      return ({ err });
    });
};

export const deletePlannerRequestsTypes = ({ ids }) => (dispatch) => {
  dispatch(deletePlannerRequestsTypesRequest());
  return communicate({ url: 'PlannerRequestTypes', method: 'delete', getParams: Utils.objects.getQueryStringFromObject({ ids }) })
    .then(({ data }) => {
      dispatch(deletePlannerRequestsTypesSuccess(ids));
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(deletePlannerRequestsTypesFail(err));
      toastrError(err);
    });
};
